import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const GraphicNewsOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  return (
          <div
            style={{
              width: "100%",
              padding: "50px 20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "28px",
            }}
          >
            {/* Volt Yellow Sticker Label */}
            <div
              style={{
                background: "#FFE600",
                color: "#000000",
                border: "3px solid #000000",
                padding: "6px 18px",
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 900,
                fontSize: "14px",
                letterSpacing: "2.5px",
                textTransform: "uppercase",
                transform: "skewX(-8deg) rotate(1.5deg)",
                boxShadow: "3px 3px 0px rgba(0,0,0,0.15)",
              }}
            >
              {keywords?.[0] || "STAY TUNED"}
            </div>

            <h2
              style={{
                fontFamily: "'Anton', sans-serif",
                fontSize: "60px",
                fontWeight: 900,
                lineHeight: 1.1,
                color: "#111625",
                textTransform: "uppercase",
                letterSpacing: "1px",
                margin: 0,
              }}
            >
              Hit Follow For Daily Updates!
            </h2>

            {/* Slanted CTA Banner */}
            <div
              style={{
                background: "#111625",
                border: "3.5px solid #000000",
                padding: "16px 28px",
                boxShadow: "6px 6px 0px rgba(0,0,0,0.15)",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                width: "90%",
                alignItems: "center",
                transform: "skewX(-8deg) rotate(-1.5deg)",
                boxSizing: "border-box",
              }}
            >
              <span
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 900,
                  fontSize: "24px",
                  color: "#FFFFFF",
                  textTransform: "uppercase",
                  letterSpacing: "1.5px",
                }}
              >
                👉 FOLLOW FOR MORE
              </span>
              <span
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 800,
                  fontSize: "20px",
                  color: "#FFE600",
                }}
              >
                {keywords?.[1] || "@TheDigitalBullet"}
              </span>
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
